import { useCallback } from 'react';

import { ReportData, report as rawReport } from '@adsk/exo-skeleton-api';

export interface ReportRemoteValue {
  report: (data: ReportData) => ReturnType<typeof rawReport>;
}

export function useReportFactory({ scope }: { scope: string }) {
  const report = useCallback(
    (data: ReportData) =>
      rawReport({
        scope,
        ...data,
      }),
    [scope],
  );

  return { report };
}
